import { VenueOperatorTableRowType } from '../types';

export const venueOperatorRows: VenueOperatorTableRowType[] = [
  {
    label: 'ADDRESS',
    accessor: 'address',
  },
  {
    label: 'PHONE',
    accessor: 'contact.phone',
  },
  {
    label: 'FAX',
    accessor: 'contact.fax',
  },
  {
    label: 'EMAIL',
    accessor: 'contact.email',
  },
];
